// extracted by mini-css-extract-plugin
module.exports = {"button":"DemoSiteCardFooter_button__2X4KY","spinner":"DemoSiteCardFooter_spinner__f4ZXT"};